import { Component } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../model/user.class';
import { AuthHttp } from 'angular2-jwt/angular2-jwt';
import { NgTableComponent } from '../tableModel/ng-table.component';
import { NgTableFilteringDirective } from '../tableModel/ng-table-filtering.directive';
import { NgTablePagingDirective } from '../tableModel/ng-table-paging.directive';
import { NgTableSortingDirective } from '../tableModel/ng-table-sorting.directive';
import { Log } from '../model/log.class';
import { Publisher } from '../model/publisher.class';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-log-list',
    templateUrl: './log.list.component.html'
})
export class LogListComponent {

    logs: Log[];
    columns: Array<any> = [
        {
            title: 'Datum',
            name: 'dateTime',
            sort: ''
        },
        {
            title: 'Logtyp',
            name: 'logType',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Logtyp filtern' }
        },
        {
            title: 'Aktionstyp',
            name: 'actionType',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Aktionstyp filtern' }
        },
        {
            title: 'Benutzer ID',
            name: 'userId',
            sort: ''
        },
        {
            title: 'Nachricht',
            name: 'message',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Nachricht filtern' }
        },
    ];

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router) {
        if (userService.user.userType === userService.Admin) {
            userService.getAll('log').subscribe(data => this.logs = data as Log[]);
        } else {
            this.route.params.subscribe(
                (params) => {
                    userService.getBy('log', params['publisherId'], 'publisher').subscribe(data => this.logs = data as Log[]);
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/log/log.list.component.ts